module.exports = __webpack_public_path__ + "static/media/PaperFootballBkgSplash.f303bbae.png";